import { render, staticRenderFns } from "./ModalDadosRegistroNecessidade.vue?vue&type=template&id=fe07ec90&scoped=true"
import script from "./ModalDadosRegistroNecessidade.vue?vue&type=script&lang=js"
export * from "./ModalDadosRegistroNecessidade.vue?vue&type=script&lang=js"
import style0 from "./ModalDadosRegistroNecessidade.vue?vue&type=style&index=0&id=fe07ec90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe07ec90",
  null
  
)

export default component.exports